module.exports = __webpack_public_path__ + "media/images/icons/country_flags/ht-1edb246a60ec9da2615febaa26469d59.svg";